import { render } from "./template.vue?vue&type=template&id=53827e2c&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=53827e2c&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53827e2c"]])

export default __exports__